// import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
import moment from "moment";
import Checkbox from "components/Checkbox/Checkbox";

export default {
    TABLE: {
        className: "data-table-all-users",
        initialSortKey: "id",
        initialSortOrder: "desc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                );
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.includes(rowData)
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                );
            },
            canBeHidden: false
        },
        {
            label: "User ID",
            header: "ID",
            key: "id",
            sortable: true,
            canBeHidden: true,
            isHidden: true
        },
        {
            label: "Name",
            header: "NAME",
            key: "name",
            sortable: true,
            className: "title",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["name"]}</span>; // name -> title
            }
        },
        {
            label: "Email",
            header: "EMAIL",
            key: "email",
            sortable: true,
            canBeHidden: false
        },
        // {
        //     label: "Site",
        //     header: "SITE",
        //     key: "site",
        //     sortable: true,
        //     className: "site",
        //     format: ({ rowData, customTableProps }) => {
        //         return <span>{rowData.siteName}</span>;
        //     }
        // },
        {
            label: "Status",
            header: "STATUS",
            key: "status",
            sortable: true
        },
        {
            label: "Role",
            header: "ROLE",
            key: "role_str",
            sortable: true,
            format: ({ rowData }) => {
                return <span>{rowData.role_str}</span>;
            },
        },
        {
            label: "Last Modified",
            header: "MODIFIED",
            key: "last_modified",
            format: ({ rowData }) => {
                const date = rowData.last_modified ? moment(rowData.last_modified).format("MM/DD/YYYY") : "N/A";
                return <span>{date}</span>;
            },
            canBeHidden: true,
            sortable: true,
        },
        {
            label: "Date Created",
            header: "CREATED",
            key: "created_at",
            format: ({ rowData }) => {
                const date = rowData.created_at ? moment(rowData.created_at).format("MM/DD/YYYY") : "N/A";
                return <span>{date}</span>;
            },
            canBeHidden: true,
            sortable: true,
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                const actionMenuDropDown = React.createRef();
                return (
                    <ItemActionsMenu
                        ref={actionMenuDropDown}
                        actions={(() => {
                            return rowData.registered === "t" ? rowData.active === "t" ? [
                                // {
                                //     label: "Notify",
                                //     action: () => {
                                //         if (actionMenuDropDown && actionMenuDropDown.current){
                                //             actionMenuDropDown.current.handleMenuClose();
                                //         }
                                //         customTableProps.notify({ id: rowData.id });
                                //     }
                                // },
                                {
                                    label: "Deactivate",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.deactivate({ id: rowData.id });
                                    }
                                },
                                {
                                    label: "Revoke access from Org",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.revokeUserAccess(rowData);
                                    }
                                },
                                {
                                    label: "Edit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.edit(rowData);
                                    }
                                },
                            ] :
                            [
                                // {
                                //     label: "Resend Registration Email",
                                //     action: () => {
                                //         if (actionMenuDropDown && actionMenuDropDown.current){
                                //             actionMenuDropDown.current.handleMenuClose();
                                //         }
                                //         customTableProps.resendRegistrationEmail({ id: rowData.id });
                                //     }
                                // },
                                {
                                    label: "Activate",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.activate({ id: rowData.id });
                                    }
                                },
                                {
                                    label: "Edit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.edit(rowData);
                                    }
                                },
                            ] : [
                                {
                                    label: "Resend Registration Email",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.resendRegistrationEmail(rowData);
                                    }
                                },
                                {
                                    label: "Revoke access from Org",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.revokeUserAccess(rowData);
                                    }
                                },
                                {
                                    label: "Edit",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.edit(rowData);
                                    }
                                },
                            ];
                        })()}
                    />
                );
            },
        }
    ]
};
